import styled from 'styled-components'

import { Label } from '../../../primitives/shared-form-styles'

export const LineFieldList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.spacing(4)};
`

export const LineField = styled.div`
  display: flex;
  flex-direction: column;
`

export const LineHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`

export const LineTrash = styled.button`
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  margin-bottom: ${o => o.theme.spacing(2)};

  &:focus-visible {
    outline: 2px solid ${o => o.theme.color.effect.focus.outline.on.background};
    outline-offset: 2px;
  }
`

export const LineLabel = styled(Label)`
  line-height: 18px;
`
